import * as React from "react"
import { VideoPlayer } from "../videoPlayer"
import { MainMediaScreen } from "../_mainMediaScreen"
import { useRecoilValue } from "recoil"
import { watchPartyScreenSelector } from "../../../recoil/atoms/watchPartyScreen"
import { localUserIdAtom, usersSelector } from "../../../recoil/atoms/users"
import { mainWindowUserSelector } from "../../../recoil/atoms/mainWindowUser"
import useWindowSize from "../../../hooks/useWindowSize"

export const RecordPlayer = () => {
  const isWatchParty = useRecoilValue(watchPartyScreenSelector)
  const mainWindowUser = useRecoilValue(mainWindowUserSelector)
  const { screenSize } = useWindowSize()
  const mainWindowUserDetails = useRecoilValue(
    usersSelector(mainWindowUser?.uid)
  )
  const localUserId = useRecoilValue(localUserIdAtom)
  const localUser = useRecoilValue(usersSelector(localUserId))

  const mainWindowUserProperties = React.useMemo(() => {
    return {
      camEnabled: mainWindowUserDetails?.camEnabled,
      mainWindowUserId: mainWindowUser?.uid
    }
  }, [mainWindowUserDetails?.camEnabled, mainWindowUser?.uid])

  const localUserProperties = React.useMemo(() => {
    return {
      localUserId: localUser?.id,
      type: localUser?.type,
      camEnabled: localUser?.camEnabled,
      micEnabled: localUser?.micEnabled,
      permissions: localUser?.permissions,
      oldPermissions: localUser?.oldPermissions,
      mediaConnected: localUser?.mediaConnected,
      screenShareEnabled: localUser?.screenShareEnabled,
      color: localUser?.color,
      handUp: localUser?.handUp
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    localUser?.id,
    localUser?.type,
    localUser?.camEnabled,
    localUser?.micEnabled,
    localUser?.permissions,
    localUser?.oldPermissions,
    localUser?.mediaConnected,
    localUser?.screenShareEnabled,
    localUser?.handUp
  ])

  return (
    <div id="myvideo">
      {isWatchParty && (
        <VideoPlayer
          showLeave={false}
          styling={{ height: "100%", width: "100vw" }}
          isTouchDelay={true}
          maxHeightMainScreen={1000}
          overlayWidth={270}
          isSmallMainScreen={false}
          maxWidthOverlay={260}
          localUserProperties={localUserProperties}
          setShowLeaveOverlay={() => {}}
        />
      )}
      <MainMediaScreen
        isTablet={false}
        styling={{}}
        heightMainScreen={screenSize.height}
        widthMainScreen={"100%"}
        mainWindowUserProperties={mainWindowUserProperties}
        overlayWidth={"100%"}
        isSmallMainScreen={true}
        localUserProperties={localUserProperties}
        maxWidthOverlay={350}
        showButtonsOnScreen={!isWatchParty}
      />
    </div>
  )
}
